module.exports = __webpack_public_path__ + "img/foundpass.3f5af00c.jpg";